<mat-card>
    <mat-card-header>
        <mat-card-title>Búsqueda de Publicaciones</mat-card-title>
      </mat-card-header>

      <mat-card-content>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
            <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
        </div>

        <ng-container *ngIf="canView">

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <!--Formulario de busqueda-->
                <form [formGroup]="searchForm">
                    <div fxLayout="row stretch" fxLayout.xs="column">

                      <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label class="text-style">Fecha Desde</mat-label>
                            <input class="text-style" matInput [matDatepicker]="fechaDesdePicker" formControlName="FechaDesde"  (click)="fechaDesdePicker.open()">
                            <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaDesde')">
                              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #fechaDesdePicker></mat-datepicker>
                          </mat-form-field>
                        </div>

                      <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label class="text-style">Fecha Hasta</mat-label>
                                <input class="text-style" matInput [matDatepicker]="fechaHastaPicker" formControlName="FechaHasta"  (click)="fechaHastaPicker.open()">
                                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaHasta')">
                                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #fechaHastaPicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                      <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                            <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label *ngIf="!isEdificioSearching">Edificio</mat-label>
                            <mat-label *ngIf="isEdificioSearching">Cargando...</mat-label>
                            <mat-select formControlName="ComunidadId">
                                <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                            </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
                </form>

            </mat-expansion-panel>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
                <button mat-raised-button (click)="add()" *ngIf="canAdd" [disabled]="isSearching" color="accent" class="zb-button">Agregar</button>
                <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
                <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
              </div>

              <!--Grilla-->
              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                  [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                  <e-columns>
                    <e-column field='Fecha' headerText='Fecha' width=20>
                      <ng-template #template let-data>
                        <!--<div [innerHTML]="data.FechaCreacion"></div>-->
                        {{data.FechaCreacion | date:'dd/MM/yyyy'}}
                      </ng-template>
                    </e-column>
                    <e-column field='Comunidad' headerText='Edificio' width=30>
                        <ng-template #template let-data>
                            <div [innerHTML]="data.ComunidadNombre"></div>
                        </ng-template>
                    </e-column>
                    <e-column field='Titulo' headerText='Titulo' width=70>
                      <ng-template #template let-data>
                        <div>{{sharedFunctions.getOnlyTextFromHtml(data.Titulo)}}</div>
                      </ng-template>
                    </e-column>
                    <e-column field='Activo' width=20>
                      <ng-template #headerTemplate>
                        <div style="text-align: center">Activo?</div>
                      </ng-template>
                      <ng-template #template let-data>
                        <div style="text-align: center">
                          {{data.Activo ? 'Sí' : 'No'}}
                        </div>
                      </ng-template>
                    </e-column>
                    <e-column width=20>
                      <ng-template #headerTemplate>
                        <div style="text-align: center">Acciones</div>
                      </ng-template>
                      <ng-template #template let-data>
                        <div style="text-align: center">
                          <a style="cursor: pointer; margin-right: 5px" (click)="view(data)"><i class="fa fa-eye fa-1x"></i></a>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
            </div>

        </ng-container>

      </mat-card-content>

</mat-card>
